import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import PopUp from "./Component/PopUp";
import { Button, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Quill from "quill";
import "quill/dist/quill.snow.css";
const { v4: uuidv4 } = require("uuid");
import eyeIcon from "../../../../../assets/themeIcons/eye-view.svg";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import PrimaryButton from "../../../components/PrimaryButton";
import GhlMediaGallery from "components/GhlMediaGallery";
import { FaImages } from "react-icons/fa";
import "./accountDetailTabs.css";

function Events({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const navigate = useNavigate();
  const [eventsData, setEventsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const openGhlGallery = () => setGhlGalleryOpen(true);

  const handleGhlImageSelect = (pick) => {
    if (!pick?.url) return;
    setCurrentFormData((prev) => ({ ...prev, image: pick?.url, image_id: pick?._id }));
    toast.success("Image selected.");
  };

  const getEvents = async () => {
    const { response } = await AppService.events.Get({
      query: `account_id=${formData._id}&include_past=true`,
    });
    if (response) {
      setEventsData(response.data);
    }
  };

  const [applicantsPopup, setApplicantsPopup] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const [currentFormData, setCurrentFormData] = useState({
    event_name: "",
    event_date: "",
    event_description: "",
    event_start_time: "",
    event_end_time: "",
    event_location: "",
    image: null,
    image_id: null,
  });

  const closeApplicantsPopup = () => setApplicantsPopup(false);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedEvent(null);
    quillInstance.current = null;
    setCurrentFormData({
      event_name: "",
      event_date: "",
      event_description: "",
      event_start_time: "",
      event_end_time: "",
      event_location: "",
      image: null,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const image_url = currentFormData?.image || selectedEvent?.image || "";
    const image_id = currentFormData?.image_id || selectedEvent?.image_id || "";

    const descriptionHtml =
      quillInstance.current?.root?.innerHTML?.trim() ||
      currentFormData?.event_description ||
      "";

    const payload = {
      event_name: currentFormData?.event_name,
      event_date: currentFormData?.event_date,
      event_description: descriptionHtml,
      event_start_time: currentFormData?.event_start_time,
      event_end_time: currentFormData?.event_end_time,
      event_location: currentFormData?.event_location,
      image: image_url,
      image_id: image_id,
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    };

    let response;

    if (selectedEvent) {
      response = await AppService.events.Update({
        payload: { ...payload, _id: selectedEvent._id },
      });
    } else {
      response = await AppService.events.Create({ payload });
    }

    if (response) {
      handleRefresh();
      closePopup();
      setSelectedEvent(null);
      getEvents();
      toast.success(
        selectedEvent ? "Event updated successfully!" : "New event created successfully!"
      );
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const handleEdit = (event) => {
    setSelectedEvent(event);
    setCurrentFormData({
      event_name: event?.event_name,
      event_date: event?.event_date,
      event_description: event?.event_description,
      event_start_time: event?.event_start_time,
      event_end_time: event?.event_end_time,
      event_location: event?.event_location,
      image: event?.image,
      image_id: event.image_id,
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    });
    openPopup();
  };

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      const { response } = await AppService.events.Delete({
        query: `_id=${event._id}`,
      });

      if (response) {
        handleRefresh();
        getEvents();
        toast.success("Delete Successfully");
      }
    } catch (error) {
      toast.error("Error deleting attachment");
      console.error("Error deleting event:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEvents();
  }, [formData]);

  useEffect(() => {
    if (selectedEvent) {
      setCurrentFormData({
        event_name: selectedEvent?.event_name,
        event_date: selectedEvent?.event_date,
        event_description: selectedEvent?.event_description,
        event_start_time: selectedEvent?.event_start_time,
        event_end_time: selectedEvent?.event_end_time,
        event_location: selectedEvent?.event_location,
        image: selectedEvent?.image,
        image_id: selectedEvent?.image_id,
      });
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (!popup) {
      if (quillInstance.current) {
        quillInstance.current = null;
      }
      return;
    }
    const timer = setTimeout(() => {
      if (quillRef.current && !quillInstance.current) {
        quillInstance.current = new Quill(quillRef.current, {
          theme: "snow",
          placeholder: "Event description...",
          modules: {
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link", "image"],
              ["clean"],
            ],
          },
        });
      }
      if (quillInstance.current) {
        const html =
          selectedEvent?.event_description || currentFormData?.event_description || "";
        quillInstance.current.root.innerHTML = html;
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [popup, selectedEvent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setSuccess("");
  };

  const formatTo12Hour = time24 => {
    if (!time24) return "";
    const [hour, minute] = time24.split(':')
    const date = new Date()
    date.setHours(+hour)
    date.setMinutes(+minute)
    return date.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  return (
    <div className="sd-account-detail-tab">
      <p className="text-left" style={{ color: "#33a933" }}>
        {success}
      </p>
      <SoftBox>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
            <PrimaryButton showPlus type="button" onClick={openPopup} disabled={loading}>
              Add Event
            </PrimaryButton>
          </Grid>

          <Grid item xs={12}>
            <div
              className="d-flex justify-content-between"
              style={{
                margin: "10px 0px",
                padding: "20px",
                borderRadius: "18px",
                background: "#F7F7F7",
              }}
            >
              <p style={{ flex: 1, fontWeight: 600 }}>Name</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Date</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Start Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>End Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Action</p>
            </div>

            {eventsData?.map((event, index) => (
              <div
                className="d-flex justify-content-between"
                style={{
                  margin: "20px 0",
                  padding: "15px 10px",
                  borderBottom: "1px solid",
                  borderColor: "#DDDDDD",
                }}
                key={index}
              >
                <p style={{ flex: 1 }}>{event?.event_name}</p>
                <p style={{ flex: 1 }}>{event?.event_date}</p>
                <p style={{ flex: 1 }}>{formatTo12Hour(event?.event_start_time)}</p>
                <p style={{ flex: 1 }}>{formatTo12Hour(event?.event_end_time)}</p>

                <div
                  style={{ flex: 1, display: "flex", justifyContent: "flex-start", gap: "20px" }}
                >
                  <img
                    onClick={() =>
                      navigate(`../event-detail/${event._id}`, {
                        state: { event, applicants: event?.interested_users || [] },
                      })
                    }
                    width={25}
                    src={eyeIcon}
                    style={{ cursor: "pointer" }}
                    alt="View"
                  />
                  <img
                    onClick={() => handleEdit(event)}
                    disabled={loading}
                    width={20}
                    src={editIcon}
                    style={{ cursor: "pointer" }}
                    alt="Edit"
                  />
                  <img
                    onClick={() => handleDelete(event)}
                    disabled={loading}
                    width={20}
                    src={deleteIcon}
                    style={{ cursor: "pointer" }}
                    alt="Delete"
                  />
                </div>
              </div>
            ))}
          </Grid>
        </Grid>
      </SoftBox>

      <PopUp
        open={popup}
        handleClose={closePopup}
        title={selectedEvent ? "Edit Event" : "New Event"}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Name</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Name"
                  name="event_name"
                  value={currentFormData?.event_name}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Date</label>
                <input
                  type="date"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Date"
                  name="event_date"
                  value={currentFormData?.event_date}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Location</label>
                <input
                  type="text"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Location"
                  name="event_location"
                  value={currentFormData?.event_location}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className=" text-black">Start Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Start Time"
                  name="event_start_time"
                  value={currentFormData?.event_start_time}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">End Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="End Time"
                  name="event_end_time"
                  value={currentFormData?.event_end_time}
                  disabled={loading}
                  required
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Image</label>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                  <button
                    type="button"
                    onClick={openGhlGallery}
                    title="Choose from Media"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                      color: "white",
                      border: "none",
                      padding: "10px 18px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                    }}
                  >
                    <FaImages size={16} />
                    {currentFormData.image ? "Change Image" : "Select from Media"}
                  </button>
                  {currentFormData.image && (
                    <img
                      src={currentFormData.image}
                      alt="Event"
                      style={{
                        width: "72px",
                        height: "72px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #e2e8f0",
                      }}
                    />
                  )}
                </div>
              </SoftBox>
            </div>
          </div>

          <div style={{ padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Event Description</label>
              <div
                ref={quillRef}
                className="sd-account-detail-tab__quill editor"
                style={{ minHeight: "220px", background: "#fff" }}
              />
            </SoftBox>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "0 10px 10px",
            }}
          >
            <PrimaryButton type="submit" disabled={loading}>
              {selectedEvent ? "Update Event" : "Save Event"}
            </PrimaryButton>
          </div>
        </form>
      </PopUp>

      <PopUp
        open={applicantsPopup}
        handleClose={closeApplicantsPopup}
        title="Intrested Persons"
        style={{ with: "70%" }}
      >
        <div
          style={{ padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", with: "70%" }}
        >
          {applicants.length > 0 ? (
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {applicants.map((applicant, index) => (
                <li
                  key={index}
                  style={{
                    padding: "12px",
                    margin: "8px 0",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    Name: {applicant?.first_name} {applicant?.last_name}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    Business Name: {applicant?.business_name}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p
              style={{
                fontSize: "14px",
                color: "#999",
                textAlign: "center",
              }}
            >
              No one is interested in this event.
            </p>
          )}
        </div>
      </PopUp>

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImageSelect}
        title="Select Event Image"
        enableCrop
        cropAspectRatio={16 / 9}
      />
    </div>
  );
}

export default Events;